import { createMuiTheme } from "@material-ui/core/styles";

export default createMuiTheme({
  palette: {
    primary: {
      main: "#007aff"
    },
    secondary: {
      main: "#aaaaaa"
    },
    custom: {
      hybrid: "#D9BBF9",
      error: "red"
    },
    rgb: {
      primary: {
        main: "4,42,43"
      },
      secondary: {
        main: "72,169,166",
        dark: "50,118,116"
      },
      custom: {
        hybrid: "217,187,249"
      }
    }
  },
  overrides: {
    MuiButton: {
      containedSecondary: {
        color: "#ffffff"
      }
    }
  }
});

export const colors = {
  LOADING: "#007aff"
};
